<script setup lang="ts">
import CloseIcon from '@shared/assets/icon/xmark.svg';
import { h } from 'vue';

const props = defineProps<{
  visible: boolean;
  title: string;
  description: string;
  dataTn: string;
  modalClass?: string;
  modalTop?: string | number;
  modalBodyMaxHeight?: string | number;
}>();

const emit = defineEmits<{
  (event: 'update:visible', value: boolean): void;
  (event: 'cancel'): void;
}>();

const closeIconVNode = h(CloseIcon, { class: 'close-icon' });
</script>

<template>
  <a-modal
    :class="['com-modal', props.modalClass]"
    :data-tn="props.dataTn"
    :style="props.modalTop !== undefined ? { top: props.modalTop } : undefined"
    :body-style="
      props.modalBodyMaxHeight !== undefined
        ? { maxHeight: props.modalBodyMaxHeight, overflowY: 'auto' }
        : undefined
    "
    :visible="props.visible"
    :title="null"
    :footer="null"
    :mask-closable="true"
    :closable="true"
    :close-icon="closeIconVNode"
    @update:visible="emit('update:visible', $event)"
    @cancel="emit('cancel')"
  >
    <div class="modal-content">
      <h2 class="modal-title">{{ props.title }}</h2>
      <p class="modal-description">{{ props.description }}</p>
      <slot />
    </div>
    <div class="modal-buttons" v-if="$slots['modal-buttons']">
      <slot name="modal-buttons" />
    </div>
  </a-modal>
</template>

<style scoped lang="less">
@import '../../../assets/style/variables.less';

.modal-content {
  text-align: left;
  padding: 16px;

  .modal-title {
    color: @color-primary;
    font-weight: @font-weight-bold !important;
    margin-bottom: 12px;
    text-align: center;
  }

  .modal-description {
    font-size: 14px;
    color: @color-primary;
    margin-bottom: 24px;
    text-align: center;
  }
}

.modal-buttons {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
</style>